import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children, permission }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <Loader2 className="animate-spin text-[#283079]" size={40} />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/admin" state={{ from: location }} replace />;
    }

    // Check specific permission if provided
    if (permission && user.permissions && !user.permissions[permission]) {
        // Optional: Show toast or forbidden page
        return <Navigate to="/admin/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;
